export default "__VITE_ASSET__Bf5FA1ej__"